import BarLoaderAnimation from './BarLoaderAnimation';

interface FullScreenLoadingOverlayProps {
  isLoading: boolean;
  backgroundOpacity?: number;
}

export function FullScreenLoadingOverlay({
  isLoading,
  backgroundOpacity = 70,
}: FullScreenLoadingOverlayProps) {
  if (!isLoading) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center"
      style={{
        backgroundColor: `rgba(255, 255, 255, ${backgroundOpacity / 100})`,
      }}
    >
      <BarLoaderAnimation loading={true} />
    </div>
  );
}
